


















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class UiStatusBarComponent extends Vue {
  @Prop({
    default: 0
  })
  public percentage: number;

  @Prop({
    default: 0
  })
  public percentage2: number;

  @Prop({
    default: false
  })
  public rounded: boolean;

  @Prop({
    default: true
  })
  public animated: boolean;

  @Prop({
    default: false
  })
  public pageProgress: boolean;

  @Prop({
    default: 'dark'
  })
  public schema: string;

  @Prop({
    default: 'single'
  })
  public type: string;

  @Prop({
    default: 'small'
  })
  public size: string;

  @Prop({
    default: false
  })
  public dots: boolean;

  @Prop()
  public dotsObject: any[];

  public dotsObjectSample: any[] = [
    {
      id: '1',
      type: 'correct'
    },
    {
      id: '2',
      type: 'incorrect'
    },
    {
      id: '3',
      type: 'unevaluated'
    },
    {
      id: '4',
      type: 'halfright'
    },
    {
      id: '5',
      type: ['current', 'correct']
    },
    {
      id: '6',
      type: 'unanswered'
    },
    {
      id: '7',
      type: 'disabled'
    }
  ];

  public getDotClass(type: string|string[]): string {
    if (Array.isArray(type)) {
      return type.join(' ');
    }

    return type;
  }

  @Emit('dot-clicked')
  public emitDotClicked(index: number): number {
    return index;
  }
}
